import React from 'react'
import { Logs } from 'src/components/AdminPanel/Logs'

const LogsPage: React.FC = () => <Logs />

export default LogsPage
